var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconButton',{staticClass:"icon-button-shuffle",class:{ 'is-rotating': _vm.isRotating, 'is-small': _vm.size === 'small', 'is-default': _vm.size === 'default' },attrs:{"icon":"ArrowsRotateSolidIcon","small":"true","size":_vm.size === 'small' ? 12 : 16,"tooltip":'Shuffle'},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }